import { Deserializable } from '../interfaces';

export class DataUser implements Deserializable {
  idUsuario: number;
  token: string;
  esCliente: number;
  FechaInicio: Date;
  imagen: string;
  idTarjeta: number;
  nombre: string;
  empresa: string;
  idEmpresa: number;
  idTipoPuestoUsuario: number;
  llave: string = 'usuario';

  constructor() {
    this.idUsuario = 0;
    this.token = '';
    this.esCliente = 0;
    this.empresa = '';
    this.FechaInicio = new Date();
    this.imagen = '';
    this.idTarjeta = 0;
    this.nombre = '';
    this.idEmpresa = 0;
    this.idTipoPuestoUsuario = 3;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
